module.exports = __webpack_public_path__ + "media/site/images/key-features/backgrounds/background-key-features-top-left-3968d47407976e65082c6ac95d9bd604.png";